/*
 * @Autor: dc
 * @Date: 2022-02-22 17:42:50
 * @LastEditors: dc
 * @LastEditTime: 2022-02-28 09:34:29
 * @Description: 
 */
const actions = {

}

export default actions;


// WEBPACK FOOTER //
// ./src/store/actions.js


// WEBPACK FOOTER //
// ./src/store/actions.js